import React from "react";
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

// Страница для неизвестных адресов: куда пойти дальше, а не пустой экран.
const LINKS = [
  { to: "/lectures", label: "Материалы" },
  { to: "/articles", label: "Статьи" },
  { to: "/cases", label: "Клинические случаи" },
  { to: "/events", label: "События" },
];

export default function NotFound() {
  return (
    <section className="not-found">
      <Compass size={44} strokeWidth={1.6} color="#007c84" />
      <h2>Страница не найдена</h2>
      <p>Возможно, ссылка устарела или в адресе опечатка. Воспользуйтесь поиском в шапке или перейдите в раздел:</p>
      <div className="not-found-links">
        {LINKS.map(l => <Link key={l.to} to={l.to}>{l.label}</Link>)}
        <Link to="/" className="primary">На главную</Link>
      </div>
    </section>
  );
}
